/**
 * Normalizes text by removing diacritics, converting to lowercase, and trimming whitespace.
 * Useful for search and comparison.
 */
export function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim()
}
